import React, { useState } from "react";
import "../styles/NewMemberRegistration.css";

const API_BASE = "https://naxor.naxora.net";
const LOGO_SRC = "/logo.png";

const initialForm = {
  fullName: "",
  phone: "",
  whatsapp: "",
  email: "",
  country: "",
  city: "",
  investmentInterest: "",
  experienceLevel: "",
  agreement: false,
};

const readJsonSafely = async (response) => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

const pageText = {
  en: {
    chooseTitle: "Choose Your Language",
    chooseSubtitle: "Please select your preferred language to continue.",
    englishButton: "English",
    urduButton: "اردو",
    languageTitle: "Language",
    officialForm: "Official Joining Form",
    title: "Start Your Journey With NAXORA",
    intro:
      "NAXORA is a digital trading platform designed for users who want to join a professional crypto-based earning system with guidance, account management, copy trading support, and a simple joining process.",
    whatTitle: "What is NAXORA?",
    whatText:
      "NAXORA provides a structured platform where users can create an account, deposit funds, follow platform trading activity, use copy trading features, track account growth, and request withdrawals according to platform rules.",
    cards: [
      {
        title: "Why Join NAXORA?",
        text:
          "NAXORA is built for users who want a simple and guided way to participate in crypto trading without handling every market decision by themselves.",
      },
      {
        title: "How It Works",
        text:
          "After joining, the team guides you through account setup, deposit process, platform rules, copy trading access, and withdrawal process.",
      },
      {
        title: "Trading Strategy",
        text:
          "The platform focuses on controlled copy trading activity, scheduled trade sessions, risk management, and small consistent trading targets instead of random high-risk trades.",
      },
      {
        title: "Profit Information",
        text:
          "Profit depends on market conditions, trading results, account activity, and platform rules. Crypto trading includes risk, so profit is not guaranteed.",
      },
    ],
    benefitsTitle: "Joining Benefits",
    benefits: [
      "Professional account joining support from the team.",
      "Simple deposit and withdrawal guidance.",
      "Copy trading system for users who need trading guidance.",
      "Dashboard access to track account balance and activity.",
      "Team and referral system according to platform policy.",
      "Support team contact for joining and account questions.",
    ],
    policyTitle: "Fees, Rules & Risk Notice",
    policies: [
      {
        title: "Platform Fees",
        text:
          "Platform service fee, withdrawal fee, and early withdrawal fee may apply according to active account policy. The final fee details are confirmed before withdrawal processing.",
      },
      {
        title: "Deposit Rules",
        text:
          "Deposits must be sent only to the official platform address shown inside the account. Wrong network or wrong address can cause loss of funds.",
      },
      {
        title: "Withdrawal Rules",
        text:
          "Withdrawals are processed according to verification, account activity, platform timing, and active withdrawal policy.",
      },
      {
        title: "Risk Notice",
        text:
          "Crypto trading has market risk. Users should join only after understanding platform rules, fees, trading risk, and withdrawal policy.",
      },
    ],
    formTitle: "Join NAXORA Now",
    formDescription:
      "Fill this form with correct details. Our official team will contact you through phone, WhatsApp, or email.",
    personalInfo: "Personal Information",
    joiningDetails: "Joining Details",
    fullName: "Full Name *",
    phone: "Phone Number *",
    whatsapp: "WhatsApp Number *",
    email: "Email Address *",
    country: "Country *",
    city: "City *",
    joiningInterest: "Joining Interest *",
    experienceLevel: "Experience Level *",
    fullNamePlaceholder: "Enter your full name",
    phonePlaceholder: "Enter your phone number",
    whatsappPlaceholder: "Enter your WhatsApp number",
    emailPlaceholder: "Enter your email address",
    countryPlaceholder: "Enter your country",
    cityPlaceholder: "Enter your city",
    selectInterest: "Select interest",
    interestOptions: [
      "I want to understand the platform",
      "I want to join with guidance",
      "I want to start trading",
      "I was invited by a member",
    ],
    selectExperience: "Select experience",
    experienceOptions: ["Beginner", "Intermediate", "Experienced"],
    agreementTitle: "Registration Agreement",
    agreementText:
      "Please provide correct information. Fake, duplicate, or misleading details can result in rejection. The NAXORA team may contact you for joining guidance, verification, deposit support, and account setup.",
    agreement:
      "I confirm that all information provided is correct. I understand that crypto trading has risk and I agree to follow NAXORA registration, verification, deposit, withdrawal, fee, and platform rules.",
    submitting: "Submitting...",
    submit: "Submit Joining Request",
    success:
      "Your request has been submitted successfully. Our team will contact you soon.",
    failed: "Registration request failed. Please try again.",
    network: "Network error. Please check your connection and try again.",
    errors: {
      fullName: "Full name is required.",
      phone: "Phone number is required.",
      whatsapp: "WhatsApp number is required.",
      email: "Email address is required.",
      invalidEmail: "Please enter a valid email address.",
      country: "Country is required.",
      city: "City is required.",
      investmentInterest: "Joining interest is required.",
      experienceLevel: "Experience level is required.",
      agreement: "Please accept the registration agreement.",
    },
  },
  ur: {
    chooseTitle: "اپنی زبان منتخب کریں",
    chooseSubtitle: "آگے بڑھنے کے لیے اپنی پسند کی زبان منتخب کریں۔",
    englishButton: "English",
    urduButton: "اردو",
    languageTitle: "زبان",
    officialForm: "آفیشل جوائننگ فارم",
    title: "NAXORA کے ساتھ اپنا سفر شروع کریں",
    intro:
      "NAXORA ایک ڈیجیٹل ٹریڈنگ پلیٹ فارم ہے جہاں نئے صارفین آسان طریقے سے اکاؤنٹ بنا سکتے ہیں، ٹیم کی رہنمائی حاصل کر سکتے ہیں، کاپی ٹریڈنگ سسٹم کو سمجھ سکتے ہیں، اور پلیٹ فارم کے اصولوں کے مطابق اپنی اکاؤنٹ ایکٹیویٹی کو مینج کر سکتے ہیں۔",
    whatTitle: "NAXORA کیا ہے؟",
    whatText:
      "NAXORA ایک منظم پلیٹ فارم ہے جہاں صارف اکاؤنٹ بنا کر ڈپازٹ کر سکتے ہیں، پلیٹ فارم کی ٹریڈنگ ایکٹیویٹی کو فالو کر سکتے ہیں، کاپی ٹریڈنگ فیچر استعمال کر سکتے ہیں، اپنا بیلنس اور ایکٹیویٹی دیکھ سکتے ہیں، اور پلیٹ فارم پالیسی کے مطابق وِدڈرال کی درخواست دے سکتے ہیں۔",
    cards: [
      {
        title: "NAXORA کیوں جوائن کریں؟",
        text:
          "NAXORA ان صارفین کے لیے بنایا گیا ہے جو crypto trading میں guided طریقے سے شامل ہونا چاہتے ہیں اور ہر market decision خود manage نہیں کرنا چاہتے۔",
      },
      {
        title: "یہ کیسے کام کرتا ہے؟",
        text:
          "جوائن کرنے کے بعد ٹیم آپ کو account setup، deposit process، platform rules، copy trading access، اور withdrawal process کے بارے میں رہنمائی دیتی ہے۔",
      },
      {
        title: "ٹریڈنگ اسٹریٹجی",
        text:
          "پلیٹ فارم random high-risk trades کے بجائے controlled copy trading، scheduled trade sessions، risk management، اور small consistent trading targets پر focus کرتا ہے۔",
      },
      {
        title: "Profit Information",
        text:
          "Profit market conditions، trading results، account activity، اور platform rules پر depend کرتا ہے۔ Crypto trading میں risk موجود ہوتا ہے، اس لیے profit guaranteed نہیں ہوتا۔",
      },
    ],
    benefitsTitle: "جوائن کرنے کے فائدے",
    benefits: [
      "ٹیم کی طرف سے professional account joining support ملتی ہے۔",
      "Deposit اور withdrawal کے بارے میں آسان guidance دی جاتی ہے۔",
      "جن users کو trading guidance چاہیے ہو ان کے لیے copy trading system موجود ہے۔",
      "Dashboard کے ذریعے account balance اور activity track کی جا سکتی ہے۔",
      "Platform policy کے مطابق team اور referral system موجود ہے۔",
      "Joining اور account questions کے لیے support team contact کر سکتی ہے۔",
    ],
    policyTitle: "Fees, Rules اور Risk Notice",
    policies: [
      {
        title: "Platform Fees",
        text:
          "Platform service fee، withdrawal fee، اور early withdrawal fee active account policy کے مطابق apply ہو سکتی ہے۔ Final fee details withdrawal processing سے پہلے confirm کی جاتی ہیں۔",
      },
      {
        title: "Deposit Rules",
        text:
          "Deposit صرف account کے اندر show ہونے والے official platform address پر بھیجنا چاہیے۔ Wrong network یا wrong address پر funds loss ہو سکتے ہیں۔",
      },
      {
        title: "Withdrawal Rules",
        text:
          "Withdrawals verification، account activity، platform timing، اور active withdrawal policy کے مطابق process ہوتے ہیں۔",
      },
      {
        title: "Risk Notice",
        text:
          "Crypto trading میں market risk ہوتا ہے۔ User کو platform rules، fees، trading risk، اور withdrawal policy سمجھنے کے بعد ہی join کرنا چاہیے۔",
      },
    ],
    formTitle: "اب NAXORA جوائن کریں",
    formDescription:
      "یہ فارم درست معلومات کے ساتھ fill کریں۔ ہماری official team آپ سے phone، WhatsApp، یا email کے ذریعے contact کرے گی۔",
    personalInfo: "ذاتی معلومات",
    joiningDetails: "جوائننگ تفصیلات",
    fullName: "مکمل نام *",
    phone: "فون نمبر *",
    whatsapp: "واٹس ایپ نمبر *",
    email: "ای میل ایڈریس *",
    country: "ملک *",
    city: "شہر *",
    joiningInterest: "جوائننگ دلچسپی *",
    experienceLevel: "Experience Level *",
    fullNamePlaceholder: "اپنا مکمل نام لکھیں",
    phonePlaceholder: "اپنا فون نمبر لکھیں",
    whatsappPlaceholder: "اپنا واٹس ایپ نمبر لکھیں",
    emailPlaceholder: "اپنا ای میل ایڈریس لکھیں",
    countryPlaceholder: "اپنا ملک لکھیں",
    cityPlaceholder: "اپنا شہر لکھیں",
    selectInterest: "دلچسپی منتخب کریں",
    interestOptions: [
      "میں پلیٹ فارم کو سمجھنا چاہتا/چاہتی ہوں",
      "میں guidance کے ساتھ join کرنا چاہتا/چاہتی ہوں",
      "میں trading شروع کرنا چاہتا/چاہتی ہوں",
      "مجھے کسی member نے invite کیا ہے",
    ],
    selectExperience: "Experience منتخب کریں",
    experienceOptions: ["Beginner", "Intermediate", "Experienced"],
    agreementTitle: "Registration Agreement",
    agreementText:
      "براہ کرم درست معلومات فراہم کریں۔ Fake، duplicate، یا misleading details کی وجہ سے request reject ہو سکتی ہے۔ NAXORA team joining guidance، verification، deposit support، اور account setup کے لیے آپ سے contact کر سکتی ہے۔",
    agreement:
      "میں confirm کرتا/کرتی ہوں کہ میری دی گئی تمام معلومات درست ہیں۔ میں سمجھتا/سمجھتی ہوں کہ crypto trading میں risk ہوتا ہے اور میں NAXORA registration، verification، deposit، withdrawal، fee، اور platform rules کو follow کرنے پر agree کرتا/کرتی ہوں۔",
    submitting: "Submit ہو رہا ہے...",
    submit: "Joining Request Submit کریں",
    success:
      "آپ کی request کامیابی سے submit ہو گئی ہے۔ ہماری team جلد آپ سے contact کرے گی۔",
    failed: "Registration request failed. دوبارہ کوشش کریں۔",
    network: "Network error. اپنا connection check کریں اور دوبارہ کوشش کریں۔",
    errors: {
      fullName: "Full name required ہے۔",
      phone: "Phone number required ہے۔",
      whatsapp: "WhatsApp number required ہے۔",
      email: "Email address required ہے۔",
      invalidEmail: "براہ کرم valid email address لکھیں۔",
      country: "Country required ہے۔",
      city: "City required ہے۔",
      investmentInterest: "Joining interest required ہے۔",
      experienceLevel: "Experience level required ہے۔",
      agreement: "براہ کرم registration agreement accept کریں۔",
    },
  },
};

const readDirection = {
  en: "ltr",
  ur: "rtl",
};

const NewMemberRegistration = () => {
  const [formData, setFormData] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [logoError, setLogoError] = useState(false);
  const [language, setLanguage] = useState("en");
  const [languageSelected, setLanguageSelected] = useState(false);

  const text = pageText[language];

  const changeLanguage = (selectedLanguage) => {
    setLanguage(selectedLanguage);
    setLanguageSelected(true);
    setMessage({ type: "", text: "" });
  };

  const switchLanguage = (selectedLanguage) => {
    setLanguage(selectedLanguage);
    setMessage({ type: "", text: "" });
  };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (message.text) {
      setMessage({ type: "", text: "" });
    }
  };

  const validateForm = () => {
    if (!formData.fullName.trim()) {
      return text.errors.fullName;
    }

    if (!formData.phone.trim()) {
      return text.errors.phone;
    }

    if (!formData.whatsapp.trim()) {
      return text.errors.whatsapp;
    }

    if (!formData.email.trim()) {
      return text.errors.email;
    }

    if (!/^\S+@\S+\.\S+$/.test(formData.email.trim())) {
      return text.errors.invalidEmail;
    }

    if (!formData.country.trim()) {
      return text.errors.country;
    }

    if (!formData.city.trim()) {
      return text.errors.city;
    }

    if (!formData.investmentInterest.trim()) {
      return text.errors.investmentInterest;
    }

    if (!formData.experienceLevel.trim()) {
      return text.errors.experienceLevel;
    }

    if (!formData.agreement) {
      return text.errors.agreement;
    }

    return "";
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationError = validateForm();

    if (validationError) {
      setMessage({ type: "error", text: validationError });
      return;
    }

    setSubmitting(true);
    setMessage({ type: "", text: "" });

    try {
      const response = await fetch(`${API_BASE}/api/new-members`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: formData.fullName.trim(),
          phone: formData.phone.trim(),
          whatsapp: formData.whatsapp.trim(),
          email: formData.email.trim().toLowerCase(),
          country: formData.country.trim(),
          city: formData.city.trim(),
          investmentInterest: formData.investmentInterest.trim(),
          experienceLevel: formData.experienceLevel.trim(),
        }),
      });

      const data = await readJsonSafely(response);

      if (!response.ok) {
        setMessage({
          type: "error",
          text: data?.message || text.failed,
        });
        return;
      }

      setFormData(initialForm);
      setMessage({
        type: "success",
        text: data?.message || text.success,
      });
    } catch {
      setMessage({
        type: "error",
        text: text.network,
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (!languageSelected) {
    return (
      <div className="new-member-language-screen">
        <div className="new-member-language-card">
          {!logoError ? (
            <img
              src={LOGO_SRC}
              alt="NAXORA"
              className="new-member-language-logo"
              onError={() => setLogoError(true)}
            />
          ) : (
            <div className="new-member-logo-text">NAXORA</div>
          )}

          <h1>{pageText.en.chooseTitle}</h1>
          <p>{pageText.en.chooseSubtitle}</p>

          <div className="new-member-first-language-buttons">
            <button type="button" onClick={() => changeLanguage("en")}>
              English
            </button>

            <button
              type="button"
              className="new-member-urdu-first-button"
              onClick={() => changeLanguage("ur")}
            >
              اردو
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`new-member-page new-member-page-${language}`}
      dir={readDirection[language]}
    >
      <div className="new-member-overlay">
        <div className="new-member-card">
          <div className="new-member-language-box">
            <span>{text.languageTitle}</span>
            <div className="new-member-language-buttons">
              <button
                type="button"
                className={`new-member-language-option ${
                  language === "en" ? "active" : ""
                }`}
                onClick={() => switchLanguage("en")}
              >
                {text.englishButton}
              </button>

              <button
                type="button"
                className={`new-member-language-option ${
                  language === "ur" ? "active" : ""
                }`}
                onClick={() => switchLanguage("ur")}
              >
                {text.urduButton}
              </button>
            </div>
          </div>

          <div className="new-member-header">
            {!logoError ? (
              <img
                src={LOGO_SRC}
                alt="NAXORA"
                className="new-member-logo"
                onError={() => setLogoError(true)}
              />
            ) : (
              <div className="new-member-logo-text">NAXORA</div>
            )}

            <span className="new-member-badge">{text.officialForm}</span>
            <h1>{text.title}</h1>
            <p>{text.intro}</p>
          </div>

          <div className="new-member-info">
            <div className="new-member-hero-box">
              <h2>{text.whatTitle}</h2>
              <p>{text.whatText}</p>
            </div>

            <div className="new-member-info-grid">
              {text.cards.map((item) => (
                <div className="new-member-info-card" key={item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>

            <div className="new-member-benefits">
              <h2>{text.benefitsTitle}</h2>

              <div className="new-member-benefit-list">
                {text.benefits.map((item, index) => (
                  <div className="new-member-benefit-item" key={item}>
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="new-member-policy-box">
              <h2>{text.policyTitle}</h2>

              <div className="new-member-policy-grid">
                {text.policies.map((item) => (
                  <div key={item.title}>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <form className="new-member-form" onSubmit={handleSubmit}>
            <div className="new-member-form-title">
              <h2>{text.formTitle}</h2>
              <p>{text.formDescription}</p>
            </div>

            <div className="new-member-section">
              <h2>{text.personalInfo}</h2>

              <div className="new-member-grid">
                <div className="new-member-field">
                  <label>{text.fullName}</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder={text.fullNamePlaceholder}
                  />
                </div>

                <div className="new-member-field">
                  <label>{text.phone}</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder={text.phonePlaceholder}
                  />
                </div>

                <div className="new-member-field">
                  <label>{text.whatsapp}</label>
                  <input
                    type="tel"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleChange}
                    placeholder={text.whatsappPlaceholder}
                  />
                </div>

                <div className="new-member-field">
                  <label>{text.email}</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={text.emailPlaceholder}
                  />
                </div>

                <div className="new-member-field">
                  <label>{text.country}</label>
                  <input
                    type="text"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    placeholder={text.countryPlaceholder}
                  />
                </div>

                <div className="new-member-field">
                  <label>{text.city}</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder={text.cityPlaceholder}
                  />
                </div>
              </div>
            </div>

            <div className="new-member-section">
              <h2>{text.joiningDetails}</h2>

              <div className="new-member-grid">
                <div className="new-member-field">
                  <label>{text.joiningInterest}</label>
                  <select
                    name="investmentInterest"
                    value={formData.investmentInterest}
                    onChange={handleChange}
                  >
                    <option value="">{text.selectInterest}</option>
                    {text.interestOptions.map((item) => (
                      <option value={item} key={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="new-member-field">
                  <label>{text.experienceLevel}</label>
                  <select
                    name="experienceLevel"
                    value={formData.experienceLevel}
                    onChange={handleChange}
                  >
                    <option value="">{text.selectExperience}</option>
                    {text.experienceOptions.map((item) => (
                      <option value={item} key={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="new-member-rules">
              <h2>{text.agreementTitle}</h2>
              <p>{text.agreementText}</p>

              <label className="new-member-agreement">
                <input
                  type="checkbox"
                  name="agreement"
                  checked={formData.agreement}
                  onChange={handleChange}
                />
                <span>{text.agreement}</span>
              </label>
            </div>

            {message.text && (
              <div className={`new-member-message ${message.type}`}>
                {message.text}
              </div>
            )}

            <button
              type="submit"
              className="new-member-submit"
              disabled={submitting}
            >
              {submitting ? text.submitting : text.submit}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewMemberRegistration;